import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import { Stack } from '@mui/material';

import { CustodyLogs } from './CustodyLogs';
import { PropertyModalFooter } from './PropertyModalFooter';
import { SideModalTitle } from './SideModalTitle';

export const PropertyPrintCustodyLogs = () => {
  const printingArea = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({});

  return (
    <Stack>
      <SideModalTitle titleClassName="customVariant">
        Print custody log
      </SideModalTitle>
      <Stack>
        <CustodyLogs isPrint ref={printingArea} />
      </Stack>
      <PropertyModalFooter
        onPrint={() => handlePrint(() => printingArea.current)}
      />
    </Stack>
  );
};
